import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../../components/common/header";
import { gql, useMutation, useQuery } from "@apollo/client";
import { GET_SELLER_STORE } from "../../api/seller-store";
import { postMessage } from "../../../../core/message";
import PushTestImg from "../../../../assets/images/push-test-img.png";
import LoadingSpinnerFull from "../../../../components/common/loading-spinner/loading-spinner-full";
const STORE_CONTACTS = gql`
  query storeContacts {
    storeContacts {
      tag
      contactNumber
    }
  }
`;

const UPDATE_STORE_CONTACTS = gql`
  mutation updateStoreContacts($storeContacts: [StoreContactInput!]!) {
    updateStoreContacts(storeContacts: $storeContacts) {
      tag
      contactNumber
    }
  }
`;

const Notification = () => {
  const navigate = useNavigate();
  const { data: storeData } = useQuery(GET_SELLER_STORE, {
    fetchPolicy: "network-only",
  });
  const { data, loading, error } = useQuery(STORE_CONTACTS, {
    fetchPolicy: "network-only",
  });
  // 초기 입력란은 하나 생성
  const [contacts, setContacts] = useState([
    { id: null, contactNumber: "", tag: "" },
  ]);

  const [updateStoreContacts] = useMutation(UPDATE_STORE_CONTACTS);
  const [isPushTestClicked, setIsPushTestClicked] = useState(false);

  useEffect(() => {
    if (data?.storeContacts) {
      const initialContacts = data.storeContacts.map((contact: any) => ({
        id: contact.id,
        tag: contact.tag || "",
        contactNumber: contact.contactNumber || "",
      }));
      setContacts(initialContacts);
    }
  }, [data]);

  const handleContactInputChange = (index: number, value: string) => {
    const newContacts = [...contacts];
    newContacts[index].contactNumber = value;
    setContacts(newContacts);
  };
  const handleTagInputChange = (index: number, value: string) => {
    const newContacts = [...contacts];
    newContacts[index].tag = value;
    setContacts(newContacts);
  };

  const handleAddInput = () => {
    setContacts([...contacts, { id: null, contactNumber: "", tag: "" }]);
  };

  const handleSave = async () => {
    // 빈 전화번호가 있으면 alert
    if (contacts.some((contact) => contact.contactNumber.trim() === "")) {
      alert("전화번호를 입력해주세요.");
      return;
    }

    try {
      await updateStoreContacts({
        variables: {
          storeContacts: contacts, // [{ contactNumber: "010-xxxx-xxxx", tag: "직원1" }, ...]
        },
      });
      if (window.confirm("변경사항을 저장하시겠습니까?")) {
        navigate("/boss/home");
      }
    } catch (err) {
      console.error(err);
      alert("저장 중 오류가 발생했습니다.");
    }
  };

  const handleDeleteInput = (index: number) => {
    setContacts((prev) => prev.filter((_, i) => i !== index));
  };

  const handlePushTest = () => {
    postMessage("REQ_NOTIFICATION_TOKEN", "");
    setIsPushTestClicked(true);
  };

  if (loading) return <LoadingSpinnerFull />;
  if (error) return <div>오류 발생!</div>;

  if (!storeData?.getSellerStore) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
        <p className="text-lg mb-6 text-gray-700">
          매장이 아직 등록되지 않았습니다.
        </p>
        <button
          onClick={() => navigate("/boss/my/store-management")}
          className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 transition duration-300"
        >
          매장 추가하러 가기
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100">
      <Header
        title="알림 설정"
        showBackButton
        onBackClick={() => navigate("/boss/home", { replace: true })}
      />
      <div className="mt-6 mx-4">
        <h2 className="text-2xl font-bold mb-4 break-keep">
          주문 완료시 알림을 받을 전화번호를 입력해주세요!
          <br />
          <h3 className="text-md text-gray-500">카카오톡으로 알림이 갑니다!</h3>
        </h2>
        <div className="space-y-4 w-full">
          {contacts.map((contact, index) => (
            <div key={index} className="w-full flex gap-2">
              <div className="grid grid-cols-5 gap-2 w-full">
                <input
                  type="text"
                  placeholder="이름 (선택)"
                  value={contact.tag}
                  onChange={(e) => handleTagInputChange(index, e.target.value)}
                  className="border rounded p-2 w-full col-span-2"
                />
                <input
                  type="number"
                  placeholder="전화번호 (필수)"
                  value={contact.contactNumber}
                  onChange={(e) =>
                    handleContactInputChange(index, e.target.value)
                  }
                  className="border rounded p-2 w-full col-span-3"
                />
              </div>
              <div
                onClick={() => handleDeleteInput(index)}
                className="col-span-1 flex justify-center items-center font-medium w-12 border bg-gray-200 cursor-pointer"
              >
                삭제
              </div>
            </div>
          ))}
        </div>
        <div className="flex justify-between mt-6">
          <button
            onClick={handleAddInput}
            className="bg-green-500 text-white font-bold py-2 px-4 rounded"
          >
            전화번호 추가
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-500 px-4 py-2 border rounded text-white text-xl font-semibold"
          >
            저장하기
          </button>
        </div>
        <hr className="my-4 mt-16" />
        <div className="mt-8">
          <h3 className="text-lg font-semibold mb-2">푸시 알림 테스트</h3>
          <p className="text-gray-600 mb-4">
            아래 버튼을 눌러 푸시 알림을 테스트해보세요.
          </p>
          <button
            onClick={handlePushTest}
            disabled={isPushTestClicked}
            className={`bg-purple-500 text-white font-bold py-2 px-4 rounded ${
              isPushTestClicked ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            푸시 알림 테스트
          </button>
          {isPushTestClicked && (
            <div className="mt-4 p-4 bg-gray-100">
              <img
                src={PushTestImg}
                alt="push-test"
                className="w-full h-auto mb-4 rounded"
              />
              <p className="text-lg font-semibold text-gray-800 mb-2">
                이렇게 뜨면 정상적으로{" "}
                <span className="underline">알람을 받을 준비</span>가 된 겁니다!
              </p>
              <p className="text-md text-gray-600">
                시간이 지나도 이렇게 뜨지 않는다면 핸드폰의{" "}
                <strong>[설정] 앱</strong>에서 알림을 허용 후 다시
                시도해주세요!!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notification;
